import classNames from 'classnames';
import styled from 'styled-components';

const Bar = styled.div`
  position: absolute;
  left: calc(-1 * var(--unit));
  top: 1px;
  bottom: 1px;
  width: var(--half-unit);
  border-radius: 1px;

  &.rank-1,
  &.rank-1::before {
    background-color: #fcff63;
  }
  &.rank-2,
  &.rank-2::before {
    background-color: #99bdc8;
  }
  &.rank-3,
  &.rank-3::before {
    background-color: #ffa463;
  }
  &.isMe,
  &.isMe::before {
    background-color: var(--c-white);
  }
`;
const BarBlur = styled.div`
  position: absolute;
  left: calc(-1 * var(--unit));
  top: 1px;
  bottom: 1px;
  width: var(--half-unit);
  filter: blur(2px);

  &.rank-1 {
    background-color: #fcff63;
  }
  &.rank-2 {
    background-color: #99bdc8;
  }
  &.rank-3 {
    background-color: #ffa463;
  }
  &.isMe {
    background-color: var(--c-white);
  }
`;

type Props = { rank: number | null; isMe?: boolean };
export const PodiumBar = ({ rank, isMe }: Props) => {
  return (
    <>
      <Bar className={classNames(`rank-${rank}`, { isMe })} />
      <BarBlur className={classNames(`rank-${rank}`, { isMe })} />
    </>
  );
};
